import React, { useState, useEffect } from 'react';
import { getAlerts } from '../api';
import { FiBell } from 'react-icons/fi';

const AlertsTab = ({ user }) => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 10000);
    return () => clearInterval(interval);
  }, [user.id]);

  const fetchAlerts = async () => {
    try {
      const data = await getAlerts(user.id);
      setAlerts(data);
    } catch (err) {
      console.error('Failed to fetch alerts', err);
    }
  };

  const getAlertType = (message) => {
    if (message?.includes('Successfully') || message?.includes('joined')) return 'success';
    if (message?.includes('Error') || message?.includes('stopped due to')) return 'error';
    return 'info';
  };

  return (
    <div className="alerts-container">
      <div className="panel-header">
        <FiBell size={18} /> Alerts
      </div>
      <div className="alerts-list">
        {alerts.length === 0 ? (
          <div className="empty-state" style={{ paddingTop: '80px' }}>
            <h3>No alerts yet</h3>
            <p>Start a sniper to begin monitoring</p>
          </div>
        ) : (
          alerts.map((alert) => (
            <div key={alert.id} className={`alert-card ${getAlertType(alert.message)}`}>
              <div className="alert-header">
                <span>{new Date(alert.created_at).toLocaleString()}</span>
                <span style={{ fontWeight: '600', color: 'var(--text-normal)' }}>{alert.sniper_name}</span>
              </div>
              <div className="alert-message">{alert.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AlertsTab;
